export default {
    "baskets": {
        "baskets": "Ablagekörbe",
        "addToBasket": "Zum Ablagekorb hinzufügen",
        "removeFromBasket": "Aus dem Ablagekorb entfernen",
        "removeFromAllBaskets": "Von allen Ablagekörben entfernen",
        "removeFromAllBasketsConfirmation": "Möchten Sie dieses Eregbnis wirklich von diesen Ablagekörben entfernen: {baskets}?",
        "basketAlreadyExists": "Es existiert bereits ein Ablagekorb mit diesem Namen. Möchten Sie ihn ersetzen?",
        "noBasket": "Sie haben noch kein Dokument zu einem Ablagekorb hinzugefügt...",
        "createBasket": "Ablagekorb erstellen",
        "manageBaskets": "Ablagekörbe verwalten",
        "delete": "Diesen Ablagekorb löschen"
    },

    "editBasket": {
        "title": "Ablagekorb",
        "name": "Name"
    },

    "manageBaskets": {
        "title": "Ablagekörbe verwalten",
        "save": "Aufzeichnung",
        "reorder": "Neu sortieren",
        "remove": "Entfernen",
        "removeAll": "Alle entfernen",
        "name": "Name",
        "tooltip": {
            "export": "Exportieren sie diesen Korb"
        }
    },

    "selectBasket": {
        "title": "Ablagekorb auswählen",
        "newBasket": "Neuer Ablagekorb..."
    },

};
